import { render } from "./add-realisasi.vue?vue&type=template&id=d186990c"
import script from "./add-realisasi.vue?vue&type=script&lang=js"
export * from "./add-realisasi.vue?vue&type=script&lang=js"
script.render = render

export default script